/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const divorcePlannerStyle = {
  headline: (theme: Theme) => ({
    textAlign: "center",
    fontWeight: 500,
    fontSize: "1.5rem",
    marginTop: "0.625rem",
    marginBottom: "1.625rem",
    color: "#333333",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
    },
  }),
  contentContainer: {
    padding: "25px",
    maxWidth: "500px",
    margin: "0 auto",
  },
};

export default divorcePlannerStyle;
